<div>
  @if (jobCountry == 'IND') {
    <p>Please enter details of your graduation (mandatory) and all higher education details (if applicable).</p>
  }
  @if (jobCountry != 'IND') {
    <p>Please enter details of your highest level of completed education, any ongoing education (if applicable)
    and any education within the last 6 years, whether complete or incomplete.</p>
  }

  <p>“Education” is classed as academic qualification (e.g. A Levels, Bachelors, Masters
  etc.).</p>

  <p>We recommend you use your CV to complete this section as Bank of America will require all necessary types
    of education to be verified. Not disclosing information could lead to new requests for information as well
    as delays to your screening closure.
  </p>
</div>

<mat-divider aria-hidden="true"></mat-divider>

<mat-dialog-actions align="end">
  <button mat-raised-button class="close-button" mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>